// Facts about Unpoly, and the few Unpoly-only features, for the places where code shared with the Inertia app has
// to ask. The only shared module allowed to touch `up` (see vite-inertia-no-unpoly.mjs).

/** Whether Unpoly is loaded at all, i.e. whether this is the Unpoly app rather than the Inertia one. */
export function hasUnpoly(): boolean {
  return 'up' in window
}

/** Whether Unpoly has finished booting. Always false in the Inertia app. */
export function unpolyBooted(): boolean {
  return hasUnpoly() && up.framework.booted
}

/** Is the caller inside an Unpoly overlay (a modal)? The Inertia app's modals are `<dialog>`s; ask the DOM for those. */
export function inOverlay(): boolean {
  return hasUnpoly() && up.layer.isOverlay()
}

/** Opens `html` in a new Unpoly overlay. Resolves to a function that dismisses it again. Unpoly app only. */
export async function openOverlay(html: string): Promise<(onDismissed: () => void) => void> {
  await up.render({ target: '[up-main~="modal"]', content: html, layer: 'new' })
  return (onDismissed) => void up.layer.dismiss(null, { onFinished: onDismissed })
}
